import { render, staticRenderFns } from "./SuppliesCard.vue?vue&type=template&id=1767a503&scoped=true&"
import script from "./SuppliesCard.vue?vue&type=script&lang=js&"
export * from "./SuppliesCard.vue?vue&type=script&lang=js&"
import style0 from "./SuppliesCard.vue?vue&type=style&index=0&id=1767a503&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1767a503",
  null
  
)

export default component.exports